import React from "react";
import Checkbox from "@mui/material/Checkbox";

export default function StyledCheckBox({ ...props }) {
  return (
    <>
      <Checkbox {...props} color="primary" data-testid="StyledCheckBox-btn-test" />
    </>
  );
}
